"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MEDIAINFO_DESCRIPTION = void 0;
var MEDIAINFO_DESCRIPTION;
(function (MEDIAINFO_DESCRIPTION) {
    MEDIAINFO_DESCRIPTION["playerVersion"] = "Player engine";
    MEDIAINFO_DESCRIPTION["currentTime"] = "Current time";
    MEDIAINFO_DESCRIPTION["duration"] = "Duration";
    MEDIAINFO_DESCRIPTION["bufferLevel"] = "Buffer level";
    MEDIAINFO_DESCRIPTION["bufferedSegments"] = "Buffered Segments";
    MEDIAINFO_DESCRIPTION["videoCodec"] = "Video codec";
    MEDIAINFO_DESCRIPTION["audioCodec"] = "Audio codec";
    MEDIAINFO_DESCRIPTION["drmProtection"] = "DRM protection";
    MEDIAINFO_DESCRIPTION["resolution"] = "Resolution";
    MEDIAINFO_DESCRIPTION["bitrate"] = "Bitrate";
    MEDIAINFO_DESCRIPTION["framerate"] = "Framerate";
    MEDIAINFO_DESCRIPTION["estimatedBandwidth"] = "Estimated bandwidth";
    MEDIAINFO_DESCRIPTION["totalDataLoaded"] = "Total data loaded";
    MEDIAINFO_DESCRIPTION["corruptedVideoFrames"] = "Corrupted video frames";
    MEDIAINFO_DESCRIPTION["droppedVideoFrames"] = "Dropped video frames";
    MEDIAINFO_DESCRIPTION["liveLatency"] = "Live latency";
    MEDIAINFO_DESCRIPTION["totalNumberAds"] = "Total number of ads";
    MEDIAINFO_DESCRIPTION["adType"] = "Ad type";
    MEDIAINFO_DESCRIPTION["adTotalDuration"] = "Ad total duration";
    MEDIAINFO_DESCRIPTION["adRemainingDuration"] = "Ad remaining duration";
    MEDIAINFO_DESCRIPTION["adDuration"] = "Current ad duration";
    MEDIAINFO_DESCRIPTION["adId"] = "Current ad ID";
})(MEDIAINFO_DESCRIPTION || (exports.MEDIAINFO_DESCRIPTION = MEDIAINFO_DESCRIPTION = {}));
//# sourceMappingURL=IMediaInfo.js.map